import { useLocation } from "react-router-dom";

import Typography from "../Typography/Typography";
import styles from "./ProgressBar.module.scss";

const steps = [
	"/register/validate-identity",
	"/register/personal-data",
	"/register/last-steps",
];

const subTitle = [
	"Validación de identidad",
	"Datos personales",
	"Últimos pasos",
];

const ProgressBar = () => {
	const { pathname } = useLocation();

	const currentStepIndex = steps.findIndex((step) => pathname === step);

	return (
		<div className={styles.progressBarContainer}>
			<div className={styles.progressBarItemsContainer}>
				{steps.map((_, index) => (
					<div
						key={index}
						className={styles.progressBarItemContainer}
					>
						<div
							className={
								index <= currentStepIndex
									? styles.progressBarItemActive
									: styles.progressBarItemInactive
							}
						></div>

						{index === currentStepIndex && (
							<Typography
								variant="p2"
								className={styles.progressBarItemTitle}
								bold
							>
								{subTitle[index]}
							</Typography>
						)}
					</div>
				))}
			</div>
		</div>
	);
};

export default ProgressBar;
